export interface Match {
  id: string;
  homeTeam: string;
  awayTeam: string;
  homeScore: number | null;
  awayScore: number | null;
  status: 'live' | 'upcoming' | 'finished';
  time: string;
  category: string;
  league: string;
}

export const hotMatches: Match[] = [
  {
    id: 'm1',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: 2,
    awayScore: 1,
    status: 'live',
    time: '72\'',
    category: 'football',
    league: '西甲联赛',
  },
  {
    id: 'm2',
    homeTeam: '曼城',
    awayTeam: '利物浦',
    homeScore: 1,
    awayScore: 1,
    status: 'live',
    time: '58\'',
    category: 'football',
    league: '英超联赛',
  },
  {
    id: 'm3',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeScore: 98,
    awayScore: 92,
    status: 'live',
    time: 'Q3 4:21',
    category: 'basketball',
    league: 'NBA常规赛',
  },
  {
    id: 'm4',
    homeTeam: 'T1战队',
    awayTeam: 'GEN.G',
    homeScore: 1,
    awayScore: 0,
    status: 'live',
    time: 'BO3',
    category: 'esports',
    league: 'LCK夏季赛',
  },
  {
    id: 'm5',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeScore: null,
    awayScore: null,
    status: 'upcoming',
    time: '19:30',
    category: 'tennis',
    league: 'ATP大师赛',
  },
  {
    id: 'm6',
    homeTeam: 'AC米兰',
    awayTeam: '国际米兰',
    homeScore: null,
    awayScore: null,
    status: 'upcoming',
    time: '21:00',
    category: 'football',
    league: '意甲联赛',
  },
];